module.exports = __webpack_public_path__ + "img/j02-min.ee0d009a.png";